import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { CourseService } from '@scaffold/services/course.service';
import { ScaffoldDialogService, ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { SearchModalComponent } from '../../editor/controls/search-modal/search-modal.component';
import { Observable, Subscription } from 'rxjs';
import { TranslationService } from '@services/translation.service';
import { GradeExportService } from '@scaffold/services/grade-export.service';
import { EnvironmentService } from '@services/environment.service';


@Component({
  selector: 'app-exportmodal',
  templateUrl: './export-modal.component.html',
  styleUrls: ['./export-modal.component.scss']
})
export class ExportModalComponent implements OnInit {

  @ViewChild('contentHolder', { static: false }) private itemElements: ElementRef;
  data: any = {};
  exportSocket: Observable<any>;
  socketSubscription: Subscription;
  constructor (
    private translationService:TranslationService,
    public dialogRef: ScaffoldDialogRef,
    private http: HttpClient,
    private courseService: CourseService,
    public dialog: ScaffoldDialogService,
    private gradeExportService: GradeExportService,
    private environmentService: EnvironmentService
  ) { }
  url = environment.apiRoot + '/download/export';
  exportStarted = false;
  /**Course level export definitions*/
  courseExports = [
    {
      label: 'Raw Data TXT',
      type: 'cvs',
      format: 'txt'
    }, {
      label: 'Raw Data CSV',
      type: 'cvs',
      format: 'csv'
    }, {
      label: 'Grade Table CSV',
      type: 'grades',
      format: 'csv'
    }, {
      label: 'Discussion Posts',
      type: 'discussionsHtml',
      format: 'html'
    }, {
      label: 'Submission Files',
      type: 'files',
      format: 'zip'
    }
  ];
  /** Student specific export definitions*/
  studentExports = [
    {
      label: 'Grade List by Student',
      type: 'gradesHtml',
      format: 'html'
    },
    {
      label: 'Raw Data CSV by Student',
      type: 'csv',
      format: 'csv'
    },
    {
      label: 'Raw Data TXT by Student',
      type: 'csv',
      format: 'txt'
    }, {
      label: 'Discussion Posts by Student',
      type: 'discussionsHtml',
      format: 'html'
    }, {
      label: 'Submission Files by Student',
      type: 'files',
      format: 'zip'
    }
  ];



  ngOnInit () {
    this.gradeExportService.init();
    this.courseExports = [
      {
        label: this.translationService.getTranslatedContent('raw_data',"Raw Data"),
        type: 'cvs',
        format: 'txt'
      }, {
        label: this.translationService.getTranslatedContent('raw_data_csv',"Raw Data CSV"),
        type: 'cvs',
        format: 'csv'
      }, {
        label: this.translationService.getTranslatedContent('grade_table_csv',"Grade Table CSV"),
        type: 'grades',
        format: 'csv'
      }, {
        label: this.translationService.getTranslatedContent('discussion_posts',"Discussion Posts"),
        type: 'discussionsHtml',
        format: 'html'
      }, {
        label: this.translationService.getTranslatedContent('submission_files',"Submission Files"),
        type: 'files',
        format: 'zip'
      }
    ];


    this.studentExports = [
      {
        label: this.translationService.getTranslatedContent('grade_list_by_student','Grade List by Student'),
        type: 'gradesHtml',
        format: 'html'
      }, 
      {
        label: this.translationService.getTranslatedContent('raw_data_txt_student',"Raw Data TXT by Student"),
        type: 'cvs',
        format: 'txt'
      }, {
        label: this.translationService.getTranslatedContent('raw_data_csv_student',"Raw Data CSV by Student"),
        type: 'cvs',
        format: 'csv'
      },
      {
        label: this.translationService.getTranslatedContent('discussion_posts_by_student','Discussion Posts by Student'),
        type: 'discussionsHtml',
        format: 'html'
      }, {
        label: this.translationService.getTranslatedContent('submission_files_by_student','Submission Files by Student'),
        type: 'files',
        format: 'zip'
      }
    ];
  }

  /**
   * Trigger a course level export defined in courseExports
   * @param type Type of export
   * @param format Format of export
   */
  getData (type, format) {
    this.exportStarted = true;
    this.http.get(environment.apiRoot + `/download/${type}?course_id=${this.courseService.id}&file_format=${format}`).subscribe(data => {
      this.gradeExportService.exportStarted(data['request']);
      this.exportStarted = false;
    });
  }


  /**
   * Trigger the flow to select a student and initate an export for that student defined in studentExports
   * @param type
   */
  byStudent (type, format): void {
    this.exportStarted = true;
    this.environmentService.getInstanceDetails().subscribe((instanceDetails) => {
    console.log(instanceDetails);
    const settings: any = {
      context: {
        data: {
          context: { type: 'courses', id: this.courseService.id },
          paginate_results: true,
          type: 'data_search',
          search_type: instanceDetails.scaffoldType === 'archivev2' ? 'enrollments' : 'archiveusers',
          search_mode: "list",
          window_title: 'Select Student',
          prevent_create: true,
        },
      },
    };
    let searchRef = this.dialog.open(SearchModalComponent, settings);

    searchRef.onClose.subscribe((result) => {
      console.log(result);
      if (result) {

        this.http.get(environment.apiRoot + `/download/${type}?course_id=${this.courseService.id}&file_format=${format}&student=${result}`).subscribe(data => {
          this.exportStarted = false;
          this.gradeExportService.exportStarted(data['request']);
        });
      } else {
        this.exportStarted = false;

      }
    });
  });

  }
}